import React from 'react';
import Menu from '../../../components/Menu/Navbar';
import Header from '../../../components/Header/header';
import Logo from '../../../components/Logo/logo';
import Footer from '../../../components/Footer/footer';
import { ContainerGeneral, ElementoLista, Titulo, Lista, ContainerTexto } from '../../RioGrande/styletexto';
import FxView from '../../../components/FxView/fxview';
import FxImagenBackGround from '../../../components/FxImagenBackGround/fximagenbackground';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';


const Actividades = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />
      <FxImagenBackGround icon={faCalendarAlt} />

      <ContainerGeneral>
        <ContainerTexto>
          <Titulo>Reserva de Pistas</Titulo>
          <p>
            Disfruta de nuestras instalaciones deportivas de primer nivel.
          </p>
          <Titulo>Instalaciones Disponibles</Titulo>
   <Lista>
  <ElementoLista><strong>3 pistas rápidas de Tenis Quick</strong></ElementoLista>

  <ElementoLista><strong>Oficina de Tenis</strong></ElementoLista>

  <ElementoLista><strong>Zonas Verdes</strong></ElementoLista>

  <ElementoLista><strong>Servicios</strong></ElementoLista>

  <ElementoLista><strong>Vestuarios</strong></ElementoLista>

  <ElementoLista><strong>Cafetería-Bar</strong></ElementoLista>

  <ElementoLista><strong>Salón Interior</strong></ElementoLista>

  <ElementoLista><strong>Zona Infantil</strong></ElementoLista>

  <ElementoLista><strong>Piscina</strong></ElementoLista>

  <ElementoLista><strong>Aparcamientos a 25 metros</strong></ElementoLista>

  <ElementoLista>
    <strong>Reserva de pista al Teléfono: 647 823 316</strong>
  </ElementoLista>
</Lista>


        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
    </div>
  );
};

export default Actividades;
